import React from 'react'
import NotificationCardSkeleton from '../NotificationCard/NotificationCardSkeleton'

import styles from './notificationPanel.scss'

const NotificationsListSkeleton = () => {
  const notifications = [
    {
      id: 'notification1',
      title: null,
      image: '',
      description: null,
      createdAt: null,
      readAt: null,
      productId: null,
      platform: 1,
      deviceToken: null,
      actions: []
    },
    {
      id: 'notification2',
      title: null,
      image: '',
      description: null,
      createdAt: null,
      readAt: null,
      productId: null,
      platform: 1,
      deviceToken: null,
      actions: []
    },
    {
      id: 'notification3',
      title: null,
      image: '',
      description: null,
      createdAt: null,
      readAt: null,
      productId: null,
      platform: 1,
      deviceToken: null,
      actions: []
    }
  ]

  const NotificationsListSkeletonComponent = notifications.map(
    (notification) => {
      const { notificationId, id } = notification

      return <NotificationCardSkeleton key={notificationId || id} />
    }
  )

  return (
    <div className={styles.loading}>{NotificationsListSkeletonComponent}</div>
  )
}

export default NotificationsListSkeleton
